import React, {createContext, useContext} from 'react';

// TODO: Should pull these from the GraphQL schema
type BasicLink = {
  id: string;
  title: string;
  url: string;
};

type ShoppableLink = {
  id: string;
  title: string;
  productId: string;
};

type Link = BasicLink | ShoppableLink;

type PageContextType = {
  id: string;
  slug: string;
  productLinks: Array<Link>;
};

const PageContext = createContext<PageContextType | null>(null);

type PageProviderProps = {
  value: PageContextType;
  children: React.ReactNode;
};

export function PageContextProvider({value, children}: PageProviderProps) {
  return (
    <PageContext.Provider value={value}>
      {value && children}
    </PageContext.Provider>
  );
}

export function usePageContext() {
  return useContext(PageContext) as PageContextType;
}
